define('lq/events/actions/cq',[
    'lq/events/actions/eventAction',
    'lq/validatorGateway',
], function (EventAction, validatorGateway) {
    'use strict';

    function CQ(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(CQ, EventAction);

    CQ.typeName = 'CQ';

    CQ.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    CQ.prototype.execute = function (continuation) {
		if (this.eventData.mockMailTo) {
			this.showMail(this.eventData, continuation)
		}
		else {
			var eventName = this.mapEventName(this.eventData)
			var eventValue = this.mapArgumentValue(this.eventData)
	
			if (eventValue) this.piping.parameters.locals.setValue("ProcessId", eventValue);
			this.piping.eventing.publish(eventName, this.eventSource, eventValue, continuation, this.getEventActionIdentifier());
			continuation();
		}
    };

    CQ.prototype.mapEventName = function (eventData) {
		if (eventData.cqStartProcessId)
			return 'MP Start Process';
		if (eventData.cqStartTodo)
		    return 'MP Start Todo';
		if (eventData.cqCancelTodo)
		    return 'MP Cancel Todo';
		if (eventData.cqCancelAndContinueId)
			return 'MP Cancel Todo And Continue';
		if (eventData.cqFinishTodo)
		    return 'MP Finish Todo';
		if (eventData.cqFinishAndContinueId)
			return 'MP Finish Todo And Continue';
		if (eventData.cqFinishAll)
		    return 'MP Finish All';
		if (eventData.cqCancelAll)
		    return 'MP Cancel All';
		if (eventData.cqGoBack)
		    return 'MP Go To Previous';
        if (eventData.cqLogin)
            return 'MP Login';
		if (eventData.cqLogoff)
		    return 'MP Logoff';
		if (eventData.cqStartMock)
		    return 'MP Start Mock';
    };
    
    CQ.prototype.mapArgumentValue = function (eventData) {
		if (eventData.cqStartProcessId)
			return eventData.cqStartProcessId;
		if (eventData.cqCancelAndContinueId)
			return eventData.cqCancelAndContinueId;
		if (eventData.cqFinishAndContinueId)
			return eventData.cqFinishAndContinueId;
    };

    CQ.prototype.showMail = function (eventData, continuation) {
		var self = this;
		var messageId = Math.floor(Math.random() * 1E10);
		
		window.addEventListener('message', function (message) {
			if (message.data && message.data.type === "POPUP_CLOSED" && message.data.id === messageId)
				continuation();
		});

		validatorGateway.publishEvent({
			type: "SHOW_EMAIL_POPUP",
			id: messageId,
			mail: {
				to: eventData.mockMailTo,
				cc: eventData.mockMailCc,
				bcc: eventData.mockMailBcc,
				subject: eventData.mockMailSubject,
				body: eventData.mockMailBody,
			},
		});
	};

    return CQ;
});

